module.exports = __webpack_public_path__ + "img/klarna-1.ecbf3e7.svg";